import { clsx } from 'clsx';
import type { ContentLayoutProps } from './MasterDocument.types';

/**
 * Layout flex que organiza el contenido principal y el panel FactBox.
 * El FactBox se renderiza como sidebar estática en xl+ o como overlay en pantallas menores.
 *
 * @see MasterDocument.types - ContentLayoutProps
 */
// `factBoxOpen` / `onFactBoxClose` siguen en `ContentLayoutProps` —son parte de la
// API publica y `MasterDocument` se las pasa—, pero este layout ya no los consume:
// el propio FactBox resuelve su responsividad. No se desestructuran para no dejar
// variables muertas, y no se quitan del tipo para no romper a los consumidores.
export function ContentLayout({
  children,
  factBox,
  className,
}: ContentLayoutProps) {
  return (
    <div
      className={clsx(
        'flex flex-1 min-h-0',
        className,
      )}
    >
      {/* Main panel */}
      {/* Panel principal SIN fondo propio: el detalle de MasterCrud no pinta una
          bandeja gris detrás del contenido — la única superficie es la tarjeta
          blanca que envuelve al formulario. Con el gris, la tarjeta quedaba
          flotando sobre un fondo que ningún maestro tiene. */}
      {/* Ya NO scrollea aquí: el scroll bajó al contenedor de las pestañas dentro de
          la tarjeta (ver `MasterDocument`), para que la franja de identidad y el borde
          de la tarjeta no se vayan con el contenido. Este panel sólo acota la altura. */}
      <div className="flex-1 min-w-0 min-h-0 overflow-hidden flex flex-col">
        {children}
      </div>

      {/* FactBox — rendered by the FactBox component itself handles responsiveness.
          On xl+, it renders as a static sidebar within this flex container.
          On smaller screens, it renders as overlay/drawer independently. */}
      {factBox}
    </div>
  );
}
